export interface TaskDTO {
    id: number;
    calendarId: number;
    calendarName: string;
    calendarColor: string;
    title: string;
    text: string;
    status: string;
    creationDate: Date;
    dueDate: Date;
    statusDate: Date;
    priority: string;
    sequence: number;
    noteId: number;
}

export interface TaskWriteDTO {
    calendarId: number;
    title: string;
    text: string;
    status: string;
    creationDate: Date;
    dueDate: Date;
    statusDate: Date;
    priority: string;
    sequence: number;
    noteId: number;
}

export function createTask(calendarId: number, title: string, text: string, status: string, creationDate: Date, dueDate: Date, statusDate: Date, priority: string, sequence: number, noteId: number) {
    return {
        calendarId: calendarId, title: title, text: text, status: status, creationDate: creationDate,
        dueDate: dueDate, statusDate: statusDate, priority: priority, sequence: sequence, noteId: noteId
    }
}